import { ReactNode, useRef } from 'react';
import { ThreeEvent } from '@react-three/fiber';
import { useConfiguratorStore } from '@store/useConfiguratorStore';
import * as THREE from 'three';

interface ModelInteractionProps {
    children: ReactNode;
}

export default function ModelInteraction({ children }: ModelInteractionProps) {
    const { 
        toolMode, 
        setSelectedPart
    } = useConfiguratorStore();
    
    const groupRef = useRef<THREE.Group>(null);

    const handleClick = (e: ThreeEvent<MouseEvent>) => {
        // Only allow selection when 'select' mode is EXPLICITLY enabled
        if (toolMode !== 'select') return;

        // Iterate through intersections to find the first non-PrintArea mesh
        // This is crucial because PrintAreas are transparent meshes sitting on top
        const hit = e.intersections.find(intersect => {
            const name = intersect.object.name.toLowerCase();
            return intersect.object instanceof THREE.Mesh && 
                   intersect.object.visible && 
                   !name.includes('printarea') && 
                   !name.includes('print_area') &&
                   !name.includes('imprint') &&
                   !name.includes('outline'); // Ignore helper lines
        });

        if (hit) {
            e.stopPropagation();
            const partName = hit.object.name;
            setSelectedPart(partName);
            
            // Highlight effect could be added here or reactive in Scene
        }
    };

    return (
        <group 
            ref={groupRef}
            onClick={handleClick}
            onPointerMissed={(e) => {
                // If clicked on background, deselect
                if (e.type === 'click') {
                    setSelectedPart(null);
                }
            }}
        >
            {children}
        </group>
    );
}
